export default __webpack_public_path__ + "static/media/m_session7_6.53dca307.png";